var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-container",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
    },
    [
      _c(
        "el-container",
        [
          _c(
            "el-header",
            { attrs: { height: "42px" } },
            [
              _c("span", { staticClass: "ik-list-title" }, [
                _c(
                  "span",
                  { staticClass: "svg-container ik-list-icon" },
                  [_c("svg-icon", { attrs: { "icon-class": "database" } })],
                  1
                ),
                _vm._v(" 数据列表 "),
              ]),
              _c(
                "el-button-group",
                { staticClass: "ik-list-menu" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "ik-list-menu-btn",
                      attrs: { size: "medium" },
                    },
                    [_vm._v("新增")]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "ik-list-menu-btn",
                      attrs: { size: "medium" },
                    },
                    [_vm._v("修改")]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "ik-list-menu-btn",
                      attrs: { size: "medium" },
                    },
                    [_vm._v("详情")]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "ik-list-menu-btn",
                      attrs: { size: "medium" },
                    },
                    [_vm._v("删除")]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "ik-list-menu-btn",
                      attrs: { size: "medium" },
                    },
                    [_vm._v("导出")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-main",
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.listLoading,
                      expression: "listLoading",
                    },
                  ],
                  ref: "table",
                  staticClass: "ik-list-table",
                  attrs: {
                    data: _vm.tableData,
                    "element-loading-text": "加载中...",
                    stripe: true,
                    border: true,
                    fit: true,
                    height: "100%",
                    "header-row-class-name": "ik-list-table-header-row",
                    "header-cell-class-name": "ik-list-table-header-cell",
                    "row-class-name": "ik-list-table-body-row",
                    "cell-class-name": "ik-list-table-body-cell",
                    "highlight-current-row": true,
                  },
                },
                [
                  _c("ik-column-text", {
                    attrs: {
                      code: "code",
                      name: "编码",
                      edit: _vm.tableEditModel,
                    },
                  }),
                  _c("ik-column-text", {
                    attrs: { code: "name", name: "名称", edit: true },
                  }),
                  _c("ik-column-text", {
                    attrs: {
                      code: "nickName",
                      name: "昵称",
                      edit: _vm.tableEditModel,
                    },
                  }),
                  _c("ik-column-select", {
                    attrs: {
                      code: "sexSign",
                      name: "性别标识",
                      "key-field": "key",
                      "value-field": "value",
                      options: _vm.toJson(_vm.jsonStr.sexSign),
                      edit: _vm.tableEditModel,
                    },
                  }),
                  _c("ik-column-date", {
                    attrs: {
                      code: "birthDate",
                      name: "出生日期",
                      edit: _vm.tableEditModel,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-footer",
            { attrs: { height: "40px" } },
            [
              _c("ik-pagination", {
                ref: "ik_list_pagination",
                attrs: {
                  "page-no": _vm.pagination.pageNo,
                  "page-size": _vm.pagination.pageSize,
                  "total-count": _vm.pagination.totalCount,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }